import { Document, Page, Text, View, pdf } from '@react-pdf/renderer';

import { PdfMarkdown } from './components/PdfMarkdown';

export const generateDocumentPdf = async (
  title: string,
  content: string,
): Promise<Blob> => {
  const pdfDocument = (
    <Document>
      <Page size="LETTER" style={{ padding: '0.75in', fontFamily: 'Inter' }}>
        <View style={{ marginBottom: 16 }}>
          <Text style={{ fontSize: 18, fontWeight: 600 }}>{title}</Text>
        </View>
        <PdfMarkdown markdown={content} />
      </Page>
    </Document>
  );

  return pdf(pdfDocument).toBlob();
};
